import {useState} from 'react';
import {History} from 'history';
// import {numberFormat} from '../../../services/NumberService';
import styles from './DashboardProductsReport.module.css';
import chevronUp from '../../../assets/images/chevron-up.svg';
import chevronDown from '../../../assets/images/chevron-down.svg';
import chevronYellowRight from '../../../assets/images/chevronYellowRight.png';
import graphql from 'babel-plugin-relay/macro';
import {DashboardProductsReport_report} from './__generated__/DashboardProductsReport_report.graphql';

interface Props {
  history: History;
  salesData: DashboardProductsReport_report[];
}
interface ArrayType {
  name: string;
  readonly transactionCount: number;
  readonly transactionAmount: number;
}
export const DashboardProductsReport = ({salesData, history}: Props) => {
  const [open, setOpen] = useState(false);
  let totalSalesRollUp: DashboardProductsReport_report;
  salesData!.map((values) => {
    if (values.entity === 'rollUp') {
      totalSalesRollUp = values;
    }
  });
  const categories = totalSalesRollUp!.categories;
  const transactionsArray: ArrayType[] = [];
  if (categories.airtime) {
    transactionsArray.push({
      name: 'Airtime',
      transactionCount: categories.airtime.transactions.transactionCount,
      transactionAmount: categories.airtime.transactions.transactionAmount,
    });
  }
  if (categories.billPayments) {
    transactionsArray.push({
      name: 'Bill Payments',
      transactionCount: categories.billPayments.transactions.transactionCount,
      transactionAmount: categories.billPayments.transactions.transactionAmount,
    });
  }
  if (categories.data) {
    transactionsArray.push({
      name: 'Data',
      transactionCount: categories.data.transactions.transactionCount,
      transactionAmount: categories.data.transactions.transactionAmount,
    });
  }
  if (categories.electricity) {
    transactionsArray.push({
      name: 'Electricity',
      transactionCount: categories.electricity.transactions.transactionCount,
      transactionAmount: categories.electricity.transactions.transactionAmount,
    });
  }
  if (categories.entertainment) {
    transactionsArray.push({
      name: 'Entertainment',
      transactionCount: categories.entertainment.transactions.transactionCount,
      transactionAmount:
        categories.entertainment.transactions.transactionAmount,
    });
  }
  if (categories.other) {
    transactionsArray.push({
      name: 'Other',
      transactionCount: categories.other.transactions.transactionCount,
      transactionAmount: categories.other.transactions.transactionAmount,
    });
  }
  if (categories.ticketing) {
    transactionsArray.push({
      name: 'Ticketing',
      transactionCount: categories.ticketing.transactions.transactionCount,
      transactionAmount: categories.ticketing.transactions.transactionAmount,
    });
  }
  transactionsArray.sort((a, b) => b.transactionAmount - a.transactionAmount);
  const calculateWidth = (amount) => {
    let largest = 0;
    transactionsArray.forEach((val) => {
      if (val.transactionAmount > largest) {
        largest = val.transactionAmount;
      }
    });
    const percentage = Math.round((amount / largest) * 100);
    return `${percentage}%`;
  };

  return (
    <div className={open ? styles.root : styles.rootClosed}>
      <div
        className={styles.header}
        role="button"
        tabIndex={0}
        onClick={() => setOpen(!open)}
      >
        Product Performance
        <img className={styles.chevron} src={open ? chevronUp : chevronDown} />
      </div>
      {open && (
        <div className={styles.container}>
          <p className={styles.subHeader}>
            Total product performance per category over the last 30 days for all
            spokes
          </p>
          <div className={styles.dataBlock}>
            {transactionsArray.map((values) => {
              return (
                <div className={styles.dataRow} key={values.name}>
                  <div
                    className={styles.innerRow}
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      history.push(`reports/${values.name}/performance`)
                    }
                  >
                    <p>{values.name}</p>
                    <p className={styles.amount}>
                      <span className={styles.salesCount}>
                        {values.transactionCount} Transactions
                      </span>
                      R {values.transactionAmount.toFixed(2)}
                    </p>
                    <img
                      className={styles.chevronYellow}
                      src={chevronYellowRight}
                    />
                  </div>
                  <div
                    className={styles.separator}
                    style={{width: calculateWidth(values.transactionAmount)}}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
graphql`
  fragment DashboardProductsReport_report on DetailedSalesReport {
    entity
    categories {
      airtime {
        transactions {
          transactionCount
          transactionAmount
        }
      }
      data {
        transactions {
          transactionCount
          transactionAmount
        }
      }
      entertainment {
        transactions {
          transactionCount
          transactionAmount
        }
      }
      ticketing {
        transactions {
          transactionCount
          transactionAmount
        }
      }
      billPayments {
        transactions {
          transactionCount
          transactionAmount
        }
      }
      electricity {
        transactions {
          transactionCount
          transactionAmount
        }
      }
      other {
        transactions {
          transactionCount
          transactionAmount
        }
      }
    }
  }
`;
